export default Object.freeze({
  ADVERT_DOC_NO: 'ADVERT_DOC_NO',
  ADVERT_DOC_VERSION_NO: 'ADVERT_DOC_VERSION_NO',
  ADVERT_PARENT_DOC_NO: 'ADVERT_PARENT_DOC_NO',
  ADVERT_PARENT_DOC_VERSION_NO: 'ADVERT_PARENT_DOC_VERSION_NO',
  CLUB_SCHEME_ID: 'CLUB_SCHEME_ID',
  DESCRIPTION: 'DESCRIPTION',
  FAVOURITE_RATING: 'FAVOURITE_RATING',
  HAS_DERIVATIVES: 'HAS_DERIVATIVES',
  IS_OOS: 'IS_OOS',
  IS_SEASONAL_SKU: 'IS_SEASONAL_SKU',
  LIST_SEQUENCE: 'LIST_SEQUENCE',
  NO_THUMBNAIL: 'NO_THUMBNAIL',
  PER_COUPON_ID: 'PER_COUPON_ID',
  PRODUCT_AVERAGE_RATING: 'PRODUCT_AVERAGE_RATING',
  PROMO_ID: 'PROMO_ID',
  RECOMMENDATION_RANK: 'RECOMMENDATION_RANK',
  SECTION: 'SECTION',
  SECTION_ID: 'SECTION_ID',
  SECTION_NUMBER: 'SECTION_NUMBER',
  SECTION_SEQUENCE: 'SECTION_SEQUENCE',
  SKU: 'SKU',
});
